import { Box, Typography } from "@mui/material";

import {
  EmptyPanelMessage,
  ExploreButton,
  NestedPanel,
  SectionLabel,
} from "../primitives";
import { BODY, BORDER, MUTED, PRIMARY_BLUE } from "../tokens";

export default function CompetitiveDynamicsPanel({ competitive, onExplore }) {
  return (
    <NestedPanel sx={{ maxHeight: 457 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          mb: 1.5,
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "baseline",
            gap: 1,
            minWidth: 0,
          }}
        >
          <SectionLabel sx={{ mb: 0, flexShrink: 0 }}>
            Competitive Dynamics
          </SectionLabel>
          {competitive.subtitle ? (
            <Typography sx={{ fontSize: 12, color: MUTED }}>
              {competitive.subtitle}
            </Typography>
          ) : null}
        </Box>
        <ExploreButton onClick={onExplore} />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.25,
          minHeight: "420px",
          overflow: "auto",
          maxHeight: "435px",
        }}
      >
        {competitive.claimants.length === 0 ? (
          <Box
            flex={1}
            display="flex"
            justifyContent="center"
            flexDirection="column"
            height="100px"
          >
            <EmptyPanelMessage>No insights found</EmptyPanelMessage>
          </Box>
        ) : (
          competitive.claimants.slice(0, 5).map((claimant) => (
            <Box
              key={claimant.name}
              sx={{
                border: `1px solid ${BORDER}`,
                borderRadius: "8px",
                p: 1.5,
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: 1.5,
              }}
            >
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  sx={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: BODY,
                  }}
                >
                  {claimant.name}
                </Typography>
                <Typography sx={{ mt: 0.5, fontSize: 12, color: MUTED }}>
                  {claimant.note}
                </Typography>
              </Box>
              <Box sx={{ textAlign: "right", flexShrink: 0 }}>
                <Typography
                  sx={{
                    fontSize: 22,
                    fontWeight: 700,
                    color: PRIMARY_BLUE,
                    lineHeight: 1,
                  }}
                >
                  {claimant.claims}
                </Typography>
                <Typography
                  sx={{
                    mt: 0.25,
                    fontSize: 10,
                    fontWeight: 600,
                    letterSpacing: "0.06em",
                    textTransform: "uppercase",
                    color: MUTED,
                    whiteSpace: "nowrap",
                  }}
                >
                  Active Patients
                </Typography>
              </Box>
            </Box>
          ))
        )}
      </Box>
    </NestedPanel>
  );
}
